module.exports = __webpack_public_path__ + "static/media/csosflogo.a79ebe64.png";